// export default "http://localhost:8888/panel"
// export default
// http://192.168.0.100:8888/panel
let url = "https://cube.soroban.ua";
// url = "http://local.soroban.ua:9000";
export default url;
